/* global axios */

import ApiClient from './ApiClient';

class CannedResponse extends ApiClient {
  constructor() {
    super('canned_responses', { accountScoped: true });
  }

  get({ searchKey, scope } = {}) {
    const params = new URLSearchParams();
    if (searchKey) params.append('search', searchKey);
    // scope=mine entrega as respostas dos setores do agente mais as globais.
    if (scope) params.append('scope', scope);
    const query = params.toString();
    return axios.get(query ? `${this.url}?${query}` : this.url);
  }
}

export default new CannedResponse();
